// Vendors
import styled from 'styled-components';
// Utilities
import { convertPxsToRems } from '@openbank/cf-ui-framework';

const KycLandingViewStyled = styled.section`
  background-color: ${({ theme }) => theme.color_comp_footerpage_rwd_bg};
  border: ${convertPxsToRems({ pixels: 1, base: 16 })} solid
    ${({ theme }) => theme.color_comp_operativecontainer_stroke};
  border-radius: ${({ theme }) => theme.radius_150};
  height: auto;
  padding: ${({ theme }) => theme.spacing_150};
`;
KycLandingViewStyled.displayName = 'KycLandingViewStyled';

const KycLandingListComponentStyled = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing_250};
  margin: 0;
  list-style: none;
  padding: 0;
`;
KycLandingListComponentStyled.displayName = 'KycLandingListComponentStyled';

const KycLandingListItemComponentStyled = styled.li`
  align-items: center;
  display: flex;
  gap: ${({ theme }) => theme.spacing_250};
  margin: 0;
  padding: 0;
`;
KycLandingListItemComponentStyled.displayName = 'KycLandingListItemComponentStyled';

const KycLandingModalConsentStyled = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing_150};
`;
KycLandingModalConsentStyled.displayName = 'KycLandingModalConsentStyled';

export {
  KycLandingViewStyled,
  KycLandingListComponentStyled,
  KycLandingListItemComponentStyled,
  KycLandingModalConsentStyled,
};
